import { SupplierOnboardingRequestMessage } from '../../../types/SupplierOnboardingRequestMessage';
import { useRole } from '../../common/hooks/useRole';
import { OfferModel } from '../../offer/model/OfferModel';

import { useOrderSupplierOnboardings } from './useOrderSupplierOnboardings';
import { useRfqSupplierOnboarding } from './useRfqSupplierOnboarding';

// Resolves a single offer's onboarding role-appropriately: suppliers read it via their request for
// quote, customers and admins via the order. The non-matching query stays disabled.
export const useOfferOnboarding = (offer: OfferModel): SupplierOnboardingRequestMessage | undefined => {
    const role = useRole();
    const isSupplier = role.isSupplier();

    const orderOnboardings = useOrderSupplierOnboardings(isSupplier ? '' : offer.orderId);
    const rfqOnboarding = useRfqSupplierOnboarding(isSupplier ? offer.requestForQuoteId ?? '' : '');

    if (isSupplier) {
        return rfqOnboarding.data ?? undefined;
    }

    return orderOnboardings.data?.find((onboarding) => onboarding.requestForQuoteId === offer.requestForQuoteId);
};
